import { render, staticRenderFns } from "./OperaDemandRecordWindow.vue?vue&type=template&id=5e22233f&"
import script from "./OperaDemandRecordWindow.vue?vue&type=script&lang=js&"
export * from "./OperaDemandRecordWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports